//@flow weak
import update from 'immutability-helper'

//translate path from array to form used by update()
const pathToCommand = (path, value, command) => {
  if (path.length === 0) return {[command]: value}
  return {[path.shift()]: pathToCommand(path, value, command)}
}

//passes in the current value to the function and updates it with the new returned value.
export const applyIn = (state, path, value) => {
  const pathCommand = pathToCommand(path, value, '$apply')
  return update(state, pathCommand)
}

export const getHeroImageByProjectId = (projectId) => {
  let heroId = 0
  for (let i = 0; i < projectId.length / 2; ++i) {
    heroId += projectId.charCodeAt(i)
  }
  heroId = heroId % 4
  return require(`../assets/img/hero/${heroId}.jpg`)
}
